/**
 * 模块说明：发货通知单 dd10
 */
import { Service } from '@/tools'
export class SalesDeliveryServer<T extends TOrder.SalesDelivery> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TOrder.SalesDelivery}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 分页查询发货通知单列表信息
   * /api/order/delivery/v1/queryDeliverNoticePage
   */
  queryDeliverNoticePage = <K extends T['ApiQueryDeliverNoticePage']>(data?: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiQueryDeliverNoticePage', data)

  /**
   * 分页查询发货通知单商品列表
   * /api/order/delivery/v1/queryDeliverNoticeProductPage
   */
  queryDeliverNoticeProductPage = <K extends T['ApiQueryDeliverNoticeProductPage']>(data?: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiQueryDeliverNoticeProductPage', data)
  /**
   * 查询发货通知单详情
   * /api/order/delivery/v1/queryDeliverNoticeInfoById
   */
  queryDeliverNoticeInfoById = <K extends T['ApiQueryDeliverNoticeInfoById']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiQueryDeliverNoticeInfoById', data)
  /**
   * 分页查询物流配送信息
   * /api/order/delivery/v1/queryLogisticsInfoPage
   */
  queryLogisticsInfoPage = <K extends T['ApiQueryLogisticsInfoPage']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiQueryLogisticsInfoPage', data)
  /**
   * 分页查询效期批次信息
   * /api/order/delivery/v1/queryProductDeliveryBatchDetailPage
   */
  queryProductDeliveryBatchDetailPage = <K extends T['ApiQueryProductDeliveryBatchDetailPage']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiQueryProductDeliveryBatchDetailPage', data)
  /**
   * 分页查询分发信息列表
   * /api/order/delivery/v1/queryDistributePage
   */
  queryDistributePage = <K extends T['ApiQueryDistributePage']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiQueryDistributePage', data)
  /**
   * 查询发货通知单是否能关闭
   * /api/order/delivery/v1/queryDeliverNoticeCanClose
   */
  queryDeliverNoticeCanClose = <K extends T['ApiQueryDeliverNoticeCanClose']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiQueryDeliverNoticeCanClose', data)
  /**
   * 关闭发货通知单
   * /api/order/delivery/v1/closeDeliverNotice
   */
  closeDeliverNotice = <K extends T['ApiCloseDeliverNotice']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiCloseDeliverNotice', data,'关闭成功')
}
